import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0d1f09c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-indicator d-flex align-center" }
const _hoisted_2 = { class: "progress-step text-center" }
const _hoisted_3 = {
  key: 1,
  style: {"font-size":"12px"}
}
const _hoisted_4 = {
  key: 2,
  style: {"font-size":"12px","color":"#9e9e9e"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (index > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["progress-line", index <= $setup.currentStep ? 'bg-primary' : 'bg-grey-lighten-2'])
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_avatar, {
            size: 28,
            color: $setup.dotColor(index),
            variant: $setup.dotVariant(index),
            class: _normalizeClass({ 'pulse-dot': index === $setup.currentStep && $setup.isCustomerAction })
          }, {
            default: _withCtx(() => [
              (index < $setup.currentStep)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    size: "16",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-check")
                    ]),
                    _: 1
                  }))
                : (index === $setup.currentStep)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(index + 1), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(index + 1), 1))
            ]),
            _: 2
          }, 1032, ["color", "variant", "class"]),
          _createElementVNode("div", {
            class: _normalizeClass(["text-caption mt-1", index <= $setup.currentStep ? 'text-medium-emphasis' : 'text-disabled'])
          }, _toDisplayString(step), 3)
        ])
      ], 64))
    }), 64))
  ]))
}